import BaseEvent from './BaseEvent.js';
import { getOSM } from '../../OverworldAnimation.js';

export default class DontForgetYourStarter extends BaseEvent {
    constructor({
        identifier = 'dont_forget_your_starter',
        isActive = false,
        complete = false,
        autoComplete = false,
        objectsIdentifiers = [],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
    }

    static deserialize(data) {
        return new DontForgetYourStarter({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();
        const player = osm.player;
        osm.readText(`Hey! Don't leave without your new Pokémon!`, { speaker: '???' });
        osm.finishReading();
        osm.script(() => {
            player.ignoreEventStepCount = 1;
        });
        osm.movePlayer([{ up: 1 }]);
    }
}
